var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdobeAnimate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 103.5 103.5",
    width: 2500,
    height: 2500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#ff401f}.st1{fill:#260600}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.5 103.5H0V0h103.5v103.5zM5 98.5h93.5V5H5v93.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.8 3.8h95.9v95.9H3.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91 76.7V46.6c0-9.1-13.9-15.2-31.3-8.1v38.2H70V43.8c5.4-1.8 11.7-1 11.7 3.6v29.3H91zM39.3 21H28.1L12.7 76.1l8.6.5 4.2-15.5H42l4.1 15.5H56L39.3 21zM27.7 52.4l5.8-23.1 6.1 23.1H27.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdobeAnimate);
export default __webpack_public_path__ + "static/media/adobe-animate.9a8a273df2ece952c0f168483e5d9900.svg";
export { ForwardRef as ReactComponent };